import { downloadLink } from '@/api/download'
import { Message } from 'element-ui'
import Config from '@/config'

/**
 * @description 获取下载链接
 * @param uuid
 */
export function getDownloadLinkUtil (uuid) {
  downloadLink(uuid).then(res => {
    let code = res.status
    if (code === 200) {
      Message({
        message: '获取下载链接成功。',
        type: 'success',
        showClose: true,
        duration: 3000
      })
      window.location.href = res.body
    } else {
      Message({
        message: '获取下载链接失败！',
        type: 'error',
        showClose: true,
        duration: 5000
      })
    }
  })
}

/**
 * @description 设置文档标题
 * @param title
 * @returns {string}
 */
export function getPageTitle (title) {
  if (title) {
    return `${title} - ${Config.site_title}`
  } else {
    return Config.site_title
  }
}

/**
 * @description 去掉html中所有的标签
 * @param str
 * @returns {*}
 */
export function delHtmlTag (str) {
  return str === null ? null : str.replace(/<[^>]+>/g, '')
}
